import { getGridStringOperators, getGridDateOperators, getGridBooleanOperators, getGridNumericOperators, getGridSingleSelectOperators } from "@mui/x-data-grid-pro";
import EntityTableToolbar from "./EntityTableToolbar";
import NoRowsOverlay from "./NoRowsOverlay";
import { nbNO } from "@mui/x-data-grid-pro/locales";

export const PAGESIZE = 25;

export const INITIAL_STATE = {
  pagination: {
    paginationModel: {
      pageSize: PAGESIZE,
    }
  },
};

export const COMPONENTS = { toolbar: EntityTableToolbar, noRowsOverlay: NoRowsOverlay };

export const SX = {
  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "2px" },
  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "8px" },
  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "12px" },
  "& .MuiDataGrid-cell": {
    display: "flex",
    alignItems: "center",
  },
  '--DataGrid-overlayHeight': '240px'
};


export const autoHeight = () => "auto";


export const EDITABLE_PROPERTY = { newEditingApi: true };


export function GetFilterOperator(column) {
  switch (column.type) {
    case "boolean":
      return getGridBooleanOperators();

    case "date":
      return getGridDateOperators();

    case "dateTime":
      return getGridDateOperators(true);

    case "number":
      return getGridNumericOperators();

    case "singleSelect":
      return getGridSingleSelectOperators();

    case "string":
    default:
      return getGridStringOperators().filter(FilterStringOperators);
  }
}


function FilterStringOperators(operator) {
  switch (operator.value) {
    case "doesNotEqual": 
    case "contains":
    case "equals":
    case "startsWith":
    case "endsWith":
      return true;

    default:
      return false;
  }
}

// Patch missing translation
let locale = nbNO.components.MuiDataGrid.defaultProps.localeText;
locale.filterOperatorDoesNotEqual = locale.filterOperatorNot;
